module.exports = __webpack_public_path__ + "img/Logo-APAYM.c589eef1.png";